module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10054.2efe8a22.jpg";